import useGlobalState from '@components/Hooks/useGlobalState';
import Error from '@Shared/Error';
import React from 'react';

const ChangePasswordError: React.FC = () => {

  const [store,] = useGlobalState();

  return store.change_password?._info.message ? (
    <Error>
      <h2>Error</h2>
      <p>{store.change_password?._info.message.replace('ORA-20005:', '')}</p>
    </Error>
  ) : null;
}

export default ChangePasswordError;